module.exports = __webpack_public_path__ + "static/logos-creatives-be6a5a221580269045d21cc9d5f491c7.png";